import CXMApiClient from "../../CXMApiClient";

function initialState() {
  return {
    AutoAssist: {
      ShowModal: false,
      Data: null
    },
    SendToAutoAssistantModal: {
      ShowModal: false,
      Data: null
    }
  };
}

const state = initialState();

const getters = {
  AutoAssistModal: function(state) {
    return state.AutoAssistModal;
  },
  SendToAutoAssistantModal: function(state) {
    return state.SendToAutoAssistantModal;
  }
};

const actions = {
  openSendToAutoAssistantModal: function(context, data) {
    context.commit("openSendToAutoAssistantModal", data);
  },
  openAutoAssistModal: function(context, data) {
    context.commit("openAutoAssistModal", data);
  },
  closeAutoAssistModal: function(context) {
    context.commit("closeAutoAssistModal");
  },
  closeSendToAutoAssistantModal: function(context) {
    context.commit("closeSendToAutoAssistantModal");
  },
  viewAutoAssistCommunication: function(context, payload) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "post",
            "api/auto_assistant/full_conversation",
            payload
          )
          .then(response => {
            if (response && response.data.successful) {
              resolve(response.data.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  },
  getAutoAssistStatuses: async function(context, payload) {
    let client = new CXMApiClient();
    let response = await client.ProcessRequest(
      "post",
      "api/auto_assistant/conversica_conversation_statuses",
      payload
    );
    return response.data.data;
  },
  sendToAutoAssistant: async function(context, payload) {
    let client = new CXMApiClient();
    let response = await client.ProcessRequest(
      "post",
      "api/auto_assistant/new_request",
      payload
    );
    return response.data.data;
  },
  getAutoAssistConversationNames: async function(context, payload) {
    let client = new CXMApiClient();
    let response = await client.ProcessRequest(
      "post",
      "api/auto_assistant/conversation_name",
      payload
    );
    return response ? response.data : null;
  },
  endAutoAssistConversation: function(context, payload) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(
        await client
          .ProcessRequest(
            "post",
            "api/auto_assistant/end_conversation",
            payload
          )
          .then(response => {
            if (response && response.data.successful) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch(err => {
            reject(err);
          })
      );
    });
  }
};

const mutations = {
  openAutoAssistModal(state, data) {
    state.AutoAssist.ShowModal = true;
    state.AutoAssist.Data = data.Data;
  },
  openSendToAutoAssistantModal(state, data) {
    state.SendToAutoAssistantModal.ShowModal = true;
    state.SendToAutoAssistantModal.Data = data.Data;
  },
  closeAutoAssistModal(state) {
    state.AutoAssist.ShowModal = false;
    state.AutoAssist.Data = null;
  },
  closeSendToAutoAssistantModal(state) {
    state.SendToAutoAssistantModal.ShowModal = false;
    state.SendToAutoAssistantModal.Data = null;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/AutoAssist.js